export const hasPaymentField = (form)=>{
    const fields = form.fields || [];
    return fields.some((field)=>[
            'PRODUCT_LIST',
            'DONATION',
            'PAYMENT_INPUT',
            'FIXED_PAYMENT'
        ].includes(field.view?.fieldType));
};

//# sourceMappingURL=has-payment-fields.js.map